import React from 'react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import { Sparkles, Compass, Clock } from 'lucide-react';
import PremiumGuard from '../components/PremiumGuard';
import { useSEO } from '../hooks/useSEO';

export const DevPicksPage: React.FC = () => {
  useSEO({
    title: 'Developer Picks',
    description: 'Rekomendasi token pilihan terbaik (hot tokens) yang dianalisis secara mendalam oleh tim internal kami berdasarkan fundamental, on-chain data, dan struktur teknikal.',
    keywords: 'dev picks, analyst picks, crypto recommendation, trading dashboard, premium crypto'
  });

  return (
    <div className="flex min-h-screen bg-[#07080e] text-white font-sans">
      <Sidebar />
      <PremiumGuard requiredPlan="premium">
        <div className="flex-1 flex flex-col min-h-screen">
          <TopBar title="Dev Picks" showAccountSwitcher={true} />
          <main className="flex-1 p-6 md:p-8 flex items-center justify-center">
            <div className="max-w-md w-full bg-[#0e0f17] border border-neutral-900 rounded-3xl p-8 text-center relative overflow-hidden shadow-2xl">
              <div className="absolute -top-24 -right-24 w-48 h-48 bg-amber-600 rounded-full blur-[80px] opacity-20 pointer-events-none" />
              <div className="space-y-6">
                <div className="w-16 h-16 bg-amber-500/10 border border-amber-500/30 rounded-2xl flex items-center justify-center mx-auto text-amber-400">
                  <Compass size={32} />
                </div>
                <div className="space-y-2">
                  <div className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-amber-500/10 border border-amber-500/20 rounded-full text-[10px] font-black text-amber-400 uppercase tracking-widest">
                    <Sparkles size={10} /> Analyst Curated
                  </div>
                  <h1 className="text-2xl font-black tracking-tight text-white mt-2">Dev & Analyst Picks</h1>
                  <p className="text-xs text-neutral-400 leading-relaxed max-w-sm mx-auto">
                    Rekomendasi token pilihan terbaik (hot tokens) yang dianalisis secara mendalam oleh tim internal kami berdasarkan fundamental, on-chain data, dan struktur teknikal.
                  </p>
                </div>
                <div className="h-px bg-neutral-900 w-full" />
                <div className="flex items-center justify-center gap-2 text-[11px] font-bold text-neutral-500">
                  <Clock size={12} className="text-amber-400 animate-pulse" />
                  <span>COMING SOON — SEDANG DIKEMBANGKAN</span>
                </div>
              </div>
            </div>
          </main>
        </div>
      </PremiumGuard>
    </div>
  );
};

export default DevPicksPage;
